import { render } from "./LyricsBigBen.vue?vue&type=template&id=5696fbe4&scoped=true"
import script from "./LyricsBigBen.vue?vue&type=script&lang=js"
export * from "./LyricsBigBen.vue?vue&type=script&lang=js"

import "./LyricsBigBen.vue?vue&type=style&index=0&id=5696fbe4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5696fbe4"]])

export default __exports__